export default {
  root: {
    notes: 'Root entity type',
    message: 'Root',
  },
  region: {
    notes: 'Region entity type',
    message: 'Region',
  },
  account: {
    notes: 'Account entity type',
    message: 'Account',
  },
  site: {
    notes: 'Site entity type',
    message: 'Site',
  },
  type: {
    notes: 'Type of entity',
    message: 'Type',
  },
  notifications: {
    create: {
      success: {
        notes: 'Entity created successfully text',
        message: '{{displayName}} created successfully',
      },
    },
    delete: {
      success: {
        notes: 'Entity deleted successfully text',
        message: '{{displayName}} deleted successfully',
      },
    },
  },
  deleteEntityDialogHeader: {
    notes:
      'Dialog header used when deleting a businessentity (account, site, equipment)',
    message: 'Remove {{displayName}}',
  },
  cannotDeleteEntityDialogContent: {
    notes: 'Dialog content when delete is not possible',
    message: '{{displayName}} cannot be removed because of dependencies.',
  },
  cannotDeleteCompanyDialogContent: {
    notes: 'Dialog content when delete is not possible (company specific)',
    message:
      '{{displayName}} cannot be removed because of dependencies. Please transfer all {{displayName}} equipment to a new owner, remove all user roles from {{displayName}} and delete any sites {{displayName}} may have in order to proceed with the action.',
  },
  deleteEntityDialogContent: {
    notes:
      'Dialog content used when deleting a businessentity (account, site, equipment)',
    message: 'Are you sure you want to remove {{displayName}}?',
  },
};
